import { StyleSheet } from 'react-native';

const Styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: '#ddd'
  },
  labelContainer: {
    flexDirection: 'row',
    marginVertical: 2,
    flex: 1,
  },
  label: {
    width: 115,
    alignItems: 'flex-end',
    marginRight: 10,
    paddingTop: 2,
  },
  container: {
    flex: 1,
    backgroundColor: '#F5FCFF',
    //marginTop: (Platform.OS == 'ios') ? 20 : 0,
  },
  input: {
    padding: 10,
    margin: 10,
    height: 40,
    flex: 1,
    borderColor: 'gray',
    borderWidth: 1,
  },
  row: {
    paddingTop: 5,
    paddingLeft: 10,
    paddingRight: 10,
    borderBottomWidth: 1,
    borderBottomColor: '#808080',
  },
  item: {
    flex: 1,
    flexDirection: 'row',
  },
  definition: {
    paddingTop: 2,
  },
  heading: {
    paddingTop: 30,
    paddingLeft: 10,
    paddingRight: 10,
    borderBottomWidth: 1,
    borderBottomColor: '#808080',
    flex: 1,
    flexDirection: 'row',
  },
  modal: {
    flex: 1,
    flexDirection: 'column',
  }
});
export default Styles;
